<template>
  <!-- 文件保存位置 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="position"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">选择默认保存位置</h4>
        </div>
        <div class="modal-body">
          <div class="file-move">
            <div class id="treeview-position"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button class="btn btn-primary" type="button" @click="setUserApp">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setUserApp } from "@/api/common/index";
export default {
  name: "TableMoveSelected",
  props: {
    app: Object,
    selectedFolder: Object,
  },
  methods: {
    setUserApp() {
      if (!this.selectedFolder) {
        this.$message({
          type: "warning",
          message: "请选择目标文件夹",
        });
        return false;
      }
      setUserApp({
        app_number: this.app.app_number,
        folder_number: this.selectedFolder.number,
        group_number: null,
      })
        .then((res) => {
          if (res.status_code === 200) {
            $("#position").modal("hide");
            this.$emit("appInfo");
            this.$message({
              type: "success",
              message: res.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style>
</style>